
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.207 7.946l5.071-5.07-.707-.708L2.5 7.239v.707h.707zm.414 1H1.5V6.825l5.718-5.718a.5.5 0 01.707 0l1.414 1.415a.5.5 0 010 .707L3.62 8.946zm-2.121 1h9v1h-9v-1z","fill":"#910000"}})])
          )
        }
      }
    